import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import AdminPage from "@/pages/AdminPage";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import {
  VslSection, BeforeAfterSection, StoryChapters, RecognizeSection,
  MethodSection, MentorshipSection, AboutElioSection,
} from "@/components/landing/UomoBiblico";
import { ContactWhatsAppSection } from "@/components/landing/ContactWhatsApp";
import { FaqSection, Footer, StickyMobileCta, WhatsAppFloat } from "@/components/landing/Sections3";

const Landing = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="bg-[#080706] text-[#fbf9f5] antialiased">
      <Navbar />
      <main>
        <Hero />
        <VslSection />
        <BeforeAfterSection />
        <StoryChapters />
        <RecognizeSection />
        <MethodSection />
        <MentorshipSection />
        <AboutElioSection />
        <FaqSection />
        <ContactWhatsAppSection />
      </main>
      <Footer />
      <StickyMobileCta />
      <WhatsAppFloat />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster position="top-center" theme="dark" richColors />
    </BrowserRouter>
  );
}

export default App;
